<template>
  <div id="inboxMsg" class="animated fadeIn pt2 pb4">
    <!-- mobile layout -->
    <div class="clearfix gibson px2 mb2" v-if="showMobile">
      <div class="col-12">
        <div class="clearfix">
          <div class="col-12 mt2 px0 flex justify-between items-center">
            <p class="h4 semi-bold line-height-2 my2">Beskeder</p>
          </div>
          <div class="col-12 px0 mb2 md-hide lg-hide">
            <div class="right-align mb3">
              <router-link to="/email" class="primarycolor">E-mail</router-link>
            </div>
            <div class="py2 inboxSpecial">
              <b-tabs v-model="tabIndex" pills>
                <b-tab>
                  <template #title>
                    <span class='el-icon-download mr1'  ></span><span class='gibson'>Inbox</span>
                  </template>
                  <div class="messages gibson">
                    <b-alert class="col-12 px0 primarycolor flex justify-start items-center" :show="showDismissibleAlert">
                      <div class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-inbox-f"><path d='M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z' /></svg>
                      </div>
                      <div class="px2">Din indbakke er tom</div>
                    </b-alert>
                    <Message v-for="(email, index) in emails" @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                    </Message>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class='el-icon-upload2 mr1'  ></span><span class='gibson'>Sendte</span>
                  </template>
                  <Message v-for="(email, index) in sends"  @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                  </Message>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class='el-icon-s-promotion mr2'></span><span class='gibson'>Ny besked</span>
                  </template>
                  <div class="clearfix">
                    <b-form @submit.stop.prevent="send_service" id="formSubmit">
                      <div class="clearfix mt3">
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Til:</div>
                          <v-select label="name" v-model="to" :options="options" required>
                            <template slot="options">
                              <span class="h5 darkblue gibson"></span>
                            </template>
                            <template slot="no-options">
                              Ingen matchende ...
                            </template>
                          </v-select>
                        </div>
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Title:</div>
                          <b-form-input id="title" v-model="title" class="not-rounded muted-background p2 darkblue h5 gibson border-none" required></b-form-input>
                        </div>
                        <!-- response -->
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Notat:</div>
                          <wysiwyg placeholder="Notat" required v-model="message" />
                        </div>
                        <div class="form-group">
                          <file-upload-input :token="upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
                        </div>
                      </div>
                      <div class="clearfix">
                        <button type="submit" class="col-12 action-button p2 gibson h4 not-rounded border-none" :disabled="isLoadingReview">
                          <span class="regular">Send</span>
                          <span class="mx2">
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                    </b-form>
                  </div>
                  <div class="py4"></div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- desktop layout -->
    <div class="clearfix gibson px2 mb2 ml4" v-if="!showMobile">
      <div class="col-12">
        <div class="clearfix">
          <div class="col-12 mt2 px0 flex justify-between items-center">
            <p class="h4 semi-bold line-height-2 my2">Beskeder</p>
          </div>
          <div class="col-5 px0 mb2 xs-hide sm-hide">
            <div class="right-align">
              <router-link to="/email" class="primarycolor">E-mail</router-link>
            </div>
            <div class="py2 inboxSpecial">
              <b-tabs v-model="tabIndex" pills>
                <b-tab>
                  <template #title>
                    <span class='el-icon-download mr1' ></span><span class='gibson'>Inbox</span>
                  </template>
                  <div class="messages notosans">
                    <b-alert class="col-12 px0 primarycolor flex justify-start items-center" :show="showDismissibleAlert">
                      <div class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-inbox-f"><path d='M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z' /></svg>
                      </div>
                      <div class="px2">Din indbakke er tom</div>
                    </b-alert>
                    <Message v-for="(email, index) in emails" @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                    </Message>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class='el-icon-upload2 mr1' ></span><span class='gibson'>Sendte</span>
                  </template>
                  <Message v-for="(email, index) in sends"  @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                  </Message>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class='el-icon-s-promotion mr2'></span><span class='gibson'>Ny besked</span>
                  </template>
                  <div class="clearfix">
                    <b-form @submit.stop.prevent="send_service" id="formSubmit">
                      <div class="clearfix mt3">
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Til:</div>
                          <v-select label="name" v-model="to" :options="options" required>
                            <template slot="options">
                              <span class="h5 darkblue gibson"></span>
                            </template>
                            <template slot="no-options">
                              Ingen matchende ...
                            </template>
                          </v-select>
                        </div>
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Title:</div>
                          <b-form-input id="title" v-model="title" class="not-rounded muted-background p2 darkblue h5 gibson border-none" required></b-form-input>
                        </div>
                        <!-- response -->
                        <div class="flex flex-column mb3">
                          <div class="h5 regular darkblue mb1">Notat:</div>
                          <wysiwyg placeholder="Notat" required v-model="message" />
                        </div>
                        <div class="form-group">
                          <file-upload-input :token="upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
                        </div>
                      </div>
                      <div class="clearfix">
                        <button type="submit" class="col-12 action-button p2 gibson h4 not-rounded border-none" :disabled="isLoadingReview" v-if="showMobile">
                          <span class="regular">Send</span>
                          <span class="mx2">
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                        <button type="submit" class="action-button p2 gibson h4 not-rounded border-none" :disabled="isLoadingReview" v-if="!showMobile">
                          <span class="regular">Send</span>
                          <span class="mx2">
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                    </b-form>
                  </div>
                  <div class="py4"></div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered lazy v-model="emailShow" size="lg" ref="emailModal">
      <!-- header -->
      <div slot="modal-header" class="w-100 p-2">

      </div>
      <div class="modal-content border-none gibson p1">

        <div class="d-flex flex-column p1">
          <div class="line-height-golden h6 font-weight-bold">
            <template v-if="email.frompid !== '0'" >Til:</template>  {{ email.firstname }} {{ email.lastname }}: {{ email.title }}
          </div>
          <div>
            <span class="far fa-clock text-muted" style="position:relative;top:1px;"></span>
            <small class="text-muted">{{ moment(email.createtime).format('lll') }}</small>
          </div>
        </div>


        <b-embed type="iframe" seamless  :src="'https://www.kundematch.dk/newpartner/readmessage.php?email_id='+email.id+'&id='+salesPerson"  aspect="1by1"   ></b-embed>

      </div>
      <b-row class="mt-4" v-if="email.file.length !== 0">
        <b-col sm="12" md="2" lg="2">
          Files :
        </b-col>
        <b-col sm="12" md="6" lg="6" >
          <ul style="list-style: none;padding: 0;" class="m-t-10">
            <li v-for="(attachment, index) in email.file" class="py-1" :key="index">
              <a :href="'https://www.kundematch.dk/HenttilbudImg.php?img='+attachment" target="_blank" ><i class="el-icon-paperclip"></i> {{attachment.substring(attachment.lastIndexOf('/')+1)}}</a>
            </li>
          </ul>
        </b-col>
      </b-row>
      <!-- modalFooter -->
      <div slot="modal-footer" class="py-4 pl-2 pr-2 d-flex justify-content-end w-100">
        <b-col cols="6" class="pr-0">
          <b-btn type="button" slot="modal-ok" class="rounded float-left" variant="success" size="lg"  @click="resend_service(email)"  :disabled="isLoadingReview">
            <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"/></svg></span>Reply
          </b-btn>
        </b-col>
        <b-col cols="6" class="pl-0">
          <b-btn type="buttom" slot="modal-cancel" variant="secondary" size="lg" class="float-right rounded" @click="hideModal">
            <i class="el-icon-error mr-2"></i>Luk
          </b-btn>
        </b-col>
      </div>
    </b-modal>
    <b-modal hide-footer size="lg" centered lazy v-model="formShow" ref="formModal" class="p-2 pb-4" no-close-on-backdrop>
      <div slot="modal-header" class="pt2 px0">
        <div class="clearfix">
          <div class="col-12 px2">
            <p class="h4 darkblue gibson line-height-1 semi-bold">
              Skriv til ...
            </p>
          </div>
        </div>
      </div>
      <b-form @submit.stop.prevent="send_service" id="formSubmit">
        <div class="modal-content border-none p2">
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue mb1">Til:</div>
            <v-select label="name" v-model="to" :options="options" required>
              <template slot="options">
                <span class="h5 darkblue gibson"></span>
              </template>
              <template slot="no-options">
                Ingen matchende ...
              </template>
            </v-select>
          </div>
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue">Title:</div>
            <b-form-input id="title" v-model="title" class="not-rounded muted-background p2 darkblue h5 gibson border-none" required></b-form-input>
          </div>
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue mb1">Notat:</div>
            <wysiwyg placeholder="Notat" required v-model="message" />
          </div>
          <div class="form-group">
            <file-upload-input  :token="upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
          </div>
        </div>
        <div slot="modal-footer" class="col-12 py3 flex justify-between items-center">
          <button type="reset" @click="hideModalForm" class="standard-button p2 px3 h5 gibson border-none not-rounded justify-start items-center">
            <span></span>
            <span>Luk</span>
          </button>
          <button type="submit" class="action-button p2 px3 gibson h5 not-rounded border-none" :disabled="isLoadingReview">
            <span></span>
            <span class="regular">Send</span>
          </button>
        </div>
      </b-form>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Message from './Message'
import creditchecklist from './CreditcheckList'
import loading from 'vue-full-loading'
import fileUploadInput from '../../components/file-upload-input'
import Simplert from 'vue2-simplert'
import vSelect from 'vue-select'
export default {
  components: {
    Message,
    creditchecklist,
    loading,
    Simplert,
    fileUploadInput,
    vSelect
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
  },
  data () {
    return {
      emails: [],
      sends: [],
      options: [],
      files: [],
      starMessage: '',
      upload_token: '',
      tilbud_id: '',
      salesPerson: '',
      quotation: {
        files: [],
        info: []
      },
      title: '',
      to: '',
      load: 0,
      tabIndex: 0,
      message: '',
      email: { file: [] },
      emailShow: false,
      showDismissibleAlert: false,
      clear_quotation_attachment: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading...',
      drafts: false
    }
  },
  methods: {
    UpdateTilbud (files) {
      this.files = files
      document.querySelector('#inboxMsg .progress').classList.remove('hide')
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_message', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (this.$route.query.send === 'support' && this.load === 0) {
              this.formShow = !this.formShow
            }
            this.emails = res.resultMessage
            this.sends = res.resultSent
            this.options = res.customer
            if (this.$route.query.email) {
              var email
              for (email in this.emails) {
                if (this.emails[email].id === this.$route.query.email && this.load === 0) this.showItemDetails(this.emails[email])
              }
            }
            if (this.$route.query.cid) {
              this.tabIndex = 2
              for (var idc in this.options) {
                var customerList = this.options[idc]
                if (parseInt(customerList.cid) === parseInt(this.$route.query.cid)) {
                  this.to = { 'cid': customerList.cid, 'name': customerList.name }
                }
              }
            }
            if (res.resultMessage.length === 0) this.showDismissibleAlert = true
            if (this.$route.query.default === 'imentor') {
              this.title = 'Nyt abonnement'
              this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Prisberegning.dk'
            }
            if (this.$route.query.default === 'haandvaerker') {
              this.title = 'Nyt abonnement'
              this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Håndværker.dk'
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (email) {
      this.emailShow = !this.emailShow
      this.email = email
      if (this.email.frompid !== '0') return
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_message_read', salesPerson: this.salesPerson, email_id: email.id}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            localStorage.setItem('inbox', res.inbox)
            $('#totalInbox').html(res.inbox)
            if (res.inbox === 0) {
              $('#totalInbox').hide()
            } else {
              $('#totalInbox').show()
            }
          },
          response => {
            alert('error')
          }
        )
    },
    send_service (evt) {
      if (!this.to.cid) return
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'send_service', salesPerson: this.salesPerson, title: this.title, message: this.message, to: this.to.cid, files: JSON.stringify(this.files)}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.load = 1
              this.Reload()
              this.formShow = false
              this.title = ''
              this.message = ''
              this.files = []
              document.querySelector('#inboxMsg .progress').classList.add('hide')
              var fileList = document.querySelectorAll('#inboxMsg .upload-file-list li')
              for (var i = 0; i < fileList.length; i++) {
                fileList[i].remove()
                console.log(fileList[i])
              }
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    resend_service (email) {
      this.$refs.emailModal.hide()
      this.formShow = !this.formShow
      this.title = 'Re: ' + email.title
      console.log(email.cid + 'hgggg')
      for (var idc in this.options) {
        var customerList = this.options[idc]
        if (parseInt(customerList.cid) === parseInt(email.cid)) {
          this.to = { 'cid': customerList.cid, 'name': customerList.name }
        }
      }
    },
    mailSupport () {
      this.formShow = !this.formShow
    },
    hideModal () {
      this.$refs.emailModal.hide()
    },
    hideModalForm () {
      this.$refs.formModal.hide()
    }
  }
}
</script>
<style>
.iframe-container {
  overflow: hidden;
  /* 16:9 aspect ratio */
  padding-top: 56.25%;
  position: relative;
}

.iframe-container iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.vs__dropdown-toggle {
  border: 0;
  border-radius: 0;
  background: rgba(178,190,195, 0.2);
  padding: .5rem;
  font-family: 'canada-type-gibson';
}
.modal-header {
  padding-bottom:0;
}
.modal-footer,
.modal-header {
  border-bottom:0;
  border-top:0;
}
.tab-content {
  border:0;
  padding:0;
}
.tab-content .tab-pane {
  padding-left:0;
  padding-right: 0;
}
.tab-content .tab-pane.show {
  /* border-left: 1px solid #d1d4d7;
  border-right: 1px solid #d1d4d7; */
  position: relative;
  top: -2px;
}
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
.creditcheck-container > .card-body {
  padding: 0!important;
}
.pull-right {
  display: inline-block;
  margin-left: 1%;
}
.checkbox {
  margin-left: 1.5em;
  margin-right: 2em;
}
.star {
  margin-right: 2em;
}
.message {
  margin-left: 0px;
  padding-top: 8px;
  padding-bottom: 16px;
  cursor: pointer;
  border-bottom: 2px solid #efefef;
}
.row {
  margin-right: -15px;
}
.message a {
  color: black;

}
.message+.message {
  border-top: 1px solid #efefef;
}
.message.read {
  background: red;
}
.messages .unread {
  background: #e4e4e461 !important;
}
.message.selected {
}
.message:hover {
  margin-left: -3px!important;
  border-left: 3px solid #ccc!important;
}
.message-body {
  background: #ccc;
  margin-left: 0;
  margin-bottom: 1em;
  padding-top: 1em;
  padding-bottom: 1em;
}
.toolbar {

}
.toolbar .label-select {
  width: auto;
  display: inline;
}
.toolbar select,
.toolbar button,
.toolbar a,
.toolbar .badge {
  margin-right: .5em;
  margin-bottom: .5em;
}
footer.spacer {
  margin-bottom: 20em;
}
.label {
  margin-right: .5em;
}
.fa-close {
  cursor: pointer;
}
.form-horizontal {
  margin-left: 1em;
}
.nav-pills {
  display:  flex;
  justify-content: space-between;
}
.nav-pills > .nav-item > .nav-link {
  padding-left: 0;
  color:  rgba(0, 54, 69, 1.0)!important;
  fill:   rgba(0, 54, 69, 1.0)!important;
}
.inboxSpecial > .nav-item:nth-child(3) {
  padding-left: 1rem;
}
.nav-pills .nav-link.active {
  background-color: white;
  color:  rgb(25, 163, 192)!important;
  fill:   rgb(25, 163, 192)!important;
}
.editr--content {
  font-family: 'canada-type-gibson';
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// Inbox.vue?d6e30a06